export const SECTION = {
  PAID_VIEWPOINT: 'paid_viewpoint',
  TRAFFIC_SENTINEL: 'traffic_sentinel',
  DATA_CENTRIFUGE: 'data_centrifuge',
  HUMAN_REVIEW: 'human_review',
  SURVEY_PERFORMANCE: 'survey_performance',
  SURVEY_DESIGN: 'survey_design'
}

// Render order is the PRD's section order (Part A).
export const SECTION_LIST = [
  SECTION.PAID_VIEWPOINT,
  SECTION.TRAFFIC_SENTINEL,
  SECTION.DATA_CENTRIFUGE,
  SECTION.HUMAN_REVIEW,
  SECTION.SURVEY_PERFORMANCE
  // SECTION.SURVEY_DESIGN
]

// Plain, stable names for each section, for product analytics (Pendo) to tag by. Survey Design
// ships as Respondent Effort, so it carries that name already.
export const SECTION_ANALYTICS_NAME = {
  [SECTION.PAID_VIEWPOINT]: 'paid-viewpoint',
  [SECTION.TRAFFIC_SENTINEL]: 'traffic-sentinel',
  [SECTION.DATA_CENTRIFUGE]: 'data-centrifuge',
  [SECTION.HUMAN_REVIEW]: 'human-review',
  [SECTION.SURVEY_PERFORMANCE]: 'survey-performance',
  [SECTION.SURVEY_DESIGN]: 'respondent-effort'
}
